import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { gcpQueryKeys } from 'queries/gcp/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'
import { type GcpIntegrationSetupResponse } from 'types/api/gcp/integrations'

function fetchGcpIntegrationSetup({
  queryKey
}: QueryFunctionContext<ReturnType<typeof gcpQueryKeys.getIntegrationSetup>>) {
  return fetchQueryData<GcpIntegrationSetupResponse>(
    getEndpointWithParams(...queryKey)
  )
}

export function useGetGcpIntegrationSetup(
  options?: Omit<
    UseQueryOptions<GcpIntegrationSetupResponse, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...options,
    queryKey: gcpQueryKeys.getIntegrationSetup(currentTeamId),
    queryFn: fetchGcpIntegrationSetup
  })
}
